import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { settingsActions } from "../slices/settings";
import { getErrorMessage } from "../../utils/errorUtils";
import { BranchSettingsRequestDto } from "../../shared/dtos/branchSettings/BranchSettingsRequestDto";
import { BranchSettingsResponseDto } from "../../shared/dtos/branchSettings/BranchSettingsResponseDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";
import { clearAuthStorage } from "../../lib/storage";

export const getBranchSettings = () => async (dispatch: AppDispatch) => {
  dispatch(settingsActions.setLoadingBranchSettings());
  try {
    const { data } = await axiosInstance.get<
      ApiResponseDto<BranchSettingsResponseDto>
    >("/branch-settings", {
      headers: { requiresAuth: true },
    });
    if (data.status === ApiResponseStatus.SUCCESS && data.data) {
      dispatch(settingsActions.setBranchSettings(data.data));
    }
  } catch (error) {
    dispatch(settingsActions.setErrorBranchSettings(getErrorMessage(error)));
  }
};

export const updateBranchSettings =
  (payload: BranchSettingsRequestDto) => async (dispatch: AppDispatch) => {
    dispatch(settingsActions.setLoadingUpdateBranchSettings());
    try {
      const { data } = await axiosInstance.put<
        ApiResponseDto<BranchSettingsResponseDto>
      >("/branch-settings", payload, {
        headers: { requiresAuth: true },
      });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        toast.success(data.message || "Branch settings updated successfully!");
        dispatch(settingsActions.updateBranchSettingsSuccess(data.data));
        dispatch(
          settingsActions.setServerStatus({
            operation: "update-branch-settings",
            status: data.statusCode || 200,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(settingsActions.setErrorUpdateBranchSettings(message));
    }
  };

// --- Cache Management ---

export const clearAppCache = () => () => {
  clearAuthStorage();
  localStorage.clear();
  sessionStorage.clear();
  toast.success("Application cache cleared. Reloading...");
  setTimeout(() => {
    window.location.href = "/";
  }, 800);
};

export const resetSettingsServerStatus = () => (dispatch: AppDispatch) => {
  dispatch(settingsActions.setServerStatus(null));
};
